module.exports = __webpack_public_path__ + "static/media/RollWithItINTACRJA0015_bg_clean_v001.76d8afb8.webp";